(function () {
  const links = document.querySelectorAll(".footer-menu > li > a");

  for (const link of links) {
    link.addEventListener("click", function (e) {
      const a = e.target;
      a.dataset.open = a.dataset.open !== "true" ?? "false";
      e.preventDefault();
    });
  }
})();
